import { PlotTypes } from '@highimpact/dashboard-types';
import type { MigratedPlotFormProps } from '../../../../forms/formHandlerShared';
import { applyPlotTypeSeedingFromCatalog } from '../../../../forms/initiatorCatalogSeeding';
import { getPlotTypePrettyName } from '../../../../forms/InitiWidgetFormHandler';
import { useInitiatorCatalogBundle } from '../../../../forms/useInitiatorCatalogBundle';
import { getPlotType } from '../../../../state/dashboard-element-operations';
import WidgetTypeInitiatorForm from '../../commons/forms/WidgetTypeInitiatorForm';

const plotTypes: PlotTypes[] = [
  'timeseries',
  'scatter',
  'windrose',
  'bar',
  'ombrothermic',
];

function PlotInitiatorForm({
  project_id,
  site_id,
  ...props
}: MigratedPlotFormProps) {
  const { bundle } = useInitiatorCatalogBundle({ project_id, site_id });

  return (
    <WidgetTypeInitiatorForm
      {...props}
      project_id={project_id}
      site_id={site_id}
      typeSelectorLabel="Type de graphique"
      options={plotTypes.map((type) => ({
        id: type,
        label: getPlotTypePrettyName(type),
      }))}
      getSelectedTypeId={(config) => getPlotType(config) ?? plotTypes[0]}
      onTypeChange={(typeId, config) =>
        applyPlotTypeSeedingFromCatalog(typeId as PlotTypes, config, bundle)
      }
    />
  );
}

export default PlotInitiatorForm;
